import React, {
  createContext,
  ReactNode,
  useContext,
  useMemo,
  useState,
} from 'react';

interface IStepEventMenuOpenContextValue {
  isStepEventMenuOpen: boolean;
  setIsStepEventMenuOpen: (val: boolean) => void;
}

interface IProviderProps {
  children: ReactNode;
}

/**
 * This context is created for Formula Page - Funnel-Step.
 * Description: If no events in a step, we need to show 0.5 opacity on the entire step row.
 *              This will cause the dropdown menu becomes 0.5 opacity as well. therefore create
 *              this context to set the opacity of step row to 1 when the dropdown menu is open.
 */
export const StepEventMenuOpenContext =
  createContext<IStepEventMenuOpenContextValue>({
    isStepEventMenuOpen: false,
    setIsStepEventMenuOpen: (_: boolean) => null,
  });

export const StepEventMenuOpenContextProvider = ({
  children,
}: IProviderProps) => {
  const { isStepEventMenuOpen } = useContext(StepEventMenuOpenContext);
  const [isOpen, setIsOpen] = useState<boolean>(isStepEventMenuOpen);

  const value = useMemo(
    () => ({ isStepEventMenuOpen: isOpen, setIsStepEventMenuOpen: setIsOpen }),
    [isOpen],
  );

  return (
    <StepEventMenuOpenContext.Provider value={value}>
      {children}
    </StepEventMenuOpenContext.Provider>
  );
};
